import { ref } from "vue";
import { restClient } from "@/lib/raftApi";
import ErrorStateLinks from "@/components/raft/ErrorStateLinks.vue";
import { useMemoize } from "@vueuse/core";
import { useDrupalSettings } from "./useDrupalSettings";
import { useModulesEnabled } from "./useModulesEnabled";
import { useNotification } from "./useNotification";

const dromoApiKey = ref(null);
const dromoEnabled = ref(null);
const dromoSchema = ref({});
const groupContext = ref("");

const fetchConfig = useMemoize(async () => {
  const { dromo_api_key, enable_chemical_container_imports } =
    await restClient.get({
      path: "/import/chemical_containers/config",
      queries: {},
    });
  return { dromo_api_key, enable_chemical_container_imports };
});

const fetchSchema = useMemoize(async (queries) => {
  const schemaRes = await restClient.get({
    path: "/import/chemical_containers/schema",
    queries: queries,
  });
  return schemaRes;
});

// eslint-disable-next-line import/prefer-default-export
export function useFeatureFlag() {
  const { showNotification } = useNotification();
  const { config } = useDrupalSettings();
  const { modulesEnabled, getModules } = useModulesEnabled();

  if (config.groupContext) {
    groupContext.value = config.groupContext;
  }
  const queries = {};
  queries["rog-id"] = groupContext.value;
  if (groupContext.value) {
    queries["rog-type"] = "node";
  }

  const fetchDromoFeature = async () => {
    await getModules();
    if (modulesEnabled.value?.chemical_container) {
      try {
        const { dromo_api_key, enable_chemical_container_imports } =
          await fetchConfig();
        dromoApiKey.value = dromo_api_key;
        dromoEnabled.value = enable_chemical_container_imports;
      } catch (error) {
        showNotification("error", "Unable to initialize import tool. " + error);
        showNotification("error", ErrorStateLinks);
      } finally {
        if (dromoEnabled.value && dromoApiKey.value) {
          const schemaRes = await fetchSchema(queries);
          dromoSchema.value = schemaRes;
        }
      }
    }
  };

  return {
    dromoApiKey,
    dromoEnabled,
    dromoSchema,
    fetchDromoFeature,
    modulesEnabled,
    fetchConfig,
    fetchSchema,
  };
}
